import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../schedule/Schedule';
import { useState, useEffect } from 'react';
import './Attempt.css';
import Navbar from '../../Components/Navbar/Navbar';

const Attempt = (props) => {
  const [loading, setLoading] = useState(true);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const getPostsFromFirebase = [];

    const q = query(collection(db, 'Tests'));
    const subscriber = onSnapshot(q, (querySnapshot) => {
      querySnapshot.forEach((doc) => {
        getPostsFromFirebase.push({
          ...doc.data(), //spread operator
          key: doc.id, // `id` given to us by Firebase
        });
      });
      setPosts(getPostsFromFirebase);
      setLoading(false);
      console.log('Posts', posts);
    });

    // return cleanup function
    return () => subscriber();
  }, [loading]); // empty dependencies array => useEffect only called once

  if (loading) {
    return <h1>Loading Tests.</h1>;
  }

  return (
    <div className='col-12 m-0 p-0 container-fluid test_list_container'>
      <Navbar />
      <h1>Scheduled Tests 👇</h1>
      <div className='col-12 m-auto p-0 list_table'>
        {posts.length > 0 ? (
          posts.map((post) => (
            <li
              onClick={() => {
                props.history.push({ pathname: '/test', state: post.Url });
              }}
              className='row mx-0 px-0 list_item'
              key={post.key}
            >
              {post.Name}
            </li>
          ))
        ) : (
          <h1>No Tests Yet</h1>
        )}
      </div>
    </div>
  );
};

export default Attempt;
